<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3817_20)">
      <path
        d="M5.91003 3.28587C6.2992 3.07499 6.71233 2.9027 7.1443 2.77414V1.57729C7.1443 1.06484 7.55973 0.649414 8.07218 0.649414H9.92793C10.4404 0.649414 10.8558 1.06484 10.8558 1.57729V2.77414C11.2878 2.90269 11.7009 3.07498 12.0901 3.28586L12.9367 2.43922C13.299 2.07687 13.8865 2.07687 14.2489 2.43922L15.5611 3.75144C15.9235 4.1138 15.9235 4.7013 15.5611 5.06365L14.7145 5.91028C14.9254 6.29945 15.0977 6.71258 15.2262 7.14455H16.4231C16.9355 7.14455 17.3509 7.55997 17.3509 8.07242V9.92817C17.3509 10.4406 16.9355 10.856 16.4231 10.856H15.2262C15.0977 11.288 14.9254 11.7011 14.7145 12.0903L15.5611 12.9369C15.9235 13.2993 15.9235 13.8868 15.5611 14.2492L14.2489 15.5614C13.8865 15.9237 13.299 15.9237 12.9367 15.5614L12.09 14.7147C11.7009 14.9256 11.2878 15.0979 10.8558 15.2265V16.4233C10.8558 16.9358 10.4404 17.3512 9.92793 17.3512H8.07218C7.55973 17.3512 7.1443 16.9358 7.1443 16.4233V15.2265C6.71234 15.0979 6.29921 14.9256 5.91004 14.7147L5.0634 15.5614C4.70104 15.9237 4.11354 15.9237 3.75119 15.5614L2.43897 14.2492C2.07661 13.8868 2.07661 13.2993 2.43897 12.9369L3.28561 12.0903C3.07474 11.7011 2.90245 11.288 2.77389 10.856H1.57705C1.06459 10.856 0.64917 10.4406 0.64917 9.92817V8.07242C0.64917 7.55997 1.06459 7.14455 1.57705 7.14455H2.77389C2.90245 6.71259 3.07473 6.29946 3.28561 5.9103L2.43896 5.06365C2.0766 4.7013 2.0766 4.1138 2.43896 3.75144L3.41626 2.77414"
        stroke="#1D1E20"
        stroke-width="1.20003"
        stroke-linecap="round"
      />
      <path
        d="M8.99997 6.66522C10.2876 6.66522 11.3314 7.70905 11.3314 8.99667C11.3314 10.2843 10.2876 11.3281 8.99997 11.3281C7.71234 11.3281 6.66852 10.2843 6.66852 8.99667C6.66852 8.69913 6.72425 8.41461 6.82586 8.15298"
        stroke="#1D1E20"
        stroke-width="1.20003"
        stroke-linecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3817_20">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>